
import Component from "vue-class-component";
import {Vue} from "vue-property-decorator";
import BrandButton from "@/components/UI/renewal/BrandButton.vue";

@Component({
  components: {BrandButton}
})
export default class NotFoundContent extends Vue {
}
